import { DataType } from "@/shared/Enums";

export interface AdvancedSearchFilterItem {
  field: string;
  operator: string;
  value: string;
  type: DataType;
}

export const CreateEmptyAdvancedSearchFilterItemList = (): AdvancedSearchFilterItem[] =>
  [{ field: "", operator: "", value: "", type: DataType.Text }] as AdvancedSearchFilterItem[];
